import React from "react";
import { useInView } from "react-intersection-observer";
import ImpactStat from "./ImpactStat";

export default function ImactStats(props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });
  const { title, body, stats } = props;

  const renderStats = (stats) =>
    stats.map((stats, index) => {
      const number = Number(stats.impact_stat_number);
      const title = stats.impact_stat_job_title;

      return (
        <ImpactStat
          key={number + title}
          number={number}
          title={title}
          visible={isInView}
        />
      );
    });

  return (
    <React.Fragment>
      <a className="skip" id="skip"></a>
      <div
        //ref={slideUpRef}
        id="stats"
        className={`life-changing-stats tw-pt-40`}
      >
        <div className="container">
          <div ref={slideUpRef} className={`${isInView ? "slide-up" : ""}`}>
            <div className="col-12 text-center">
              <h2
                className="heading2"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              {body ? <p dangerouslySetInnerHTML={{ __html: body }} /> : ""}

              <div className="row justify-content-center">
                {renderStats(stats)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .life-changing-stats {
          margin-bottom: 200px;
        }
        p {
          margin-top: 24px;
        }
      `}</style>
    </React.Fragment>
  );
}
